import { FormattedMessage, useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";
import moment from "moment";

import { useGetFileImportActions } from "api/queries/file-import/useGetFileImportActions";
import { FileImportJobAction } from "api/models";
import { renderFileStatus } from "helpers/fileImportHelpers";

export default function ValidationHistoryTable() {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const currentImportId = searchParams.get("import");

  const { data } = useGetFileImportActions(currentImportId!, {
    enabled: !!currentImportId,
  });
  const fileImportActions = (data ?? []) as FileImportJobAction[];

  return (
    <>
      <h6 className="mt-50 mb-3">
        <FormattedMessage
          id="settings.fileImportTools.fileImportHistory.validationHistory"
          defaultMessage="Validation History"
        />
      </h6>

      <table className="validation-history-table">
        <thead>
          <tr>
            <th className="font-b4 text-secondary">
              <FormattedMessage id="settings.fileImportTools.fileImportHistory.fileName" defaultMessage="File Name" />
            </th>
            <th className="font-b4 text-secondary">
              <FormattedMessage id="general.status" defaultMessage="Status" />
            </th>
            <th className="font-b4 text-secondary">
              <FormattedMessage
                id="settings.fileImportTools.fileImportHistory.successUploaded"
                defaultMessage="Success / Uploaded"
              />
            </th>
            <th className="font-b4 text-secondary">
              <FormattedMessage id="general.error" defaultMessage="Error" />
            </th>
            <th className="font-b4 text-secondary">
              <FormattedMessage id="settings.fileImportTools.fileImportHistory.uploadedOn" defaultMessage="Uploaded On" />
            </th>
          </tr>
        </thead>
        <tbody>
          {fileImportActions.map((action, index) => (
            <tr key={index}>
              <td>{action.uploaded_file?.filename}</td>
              <td>{renderFileStatus(action.status, intl)}</td>
              <td>{action.total_imported_rows?.toLocaleString()}</td>
              <td>{action.total_failed_rows?.toLocaleString()}</td>
              <td>{moment(action.created, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY HH:mm")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
